import request from '@/libs/request'

/**
 * 获取门店列表
 * getStoresList => finanace
 * getManageStoresList => manane
 * @param {String} type 订单标识
 * @param {Number} id 订单id
 */

export function getStoresList(params) {
  return request({
    url: '/operating/merchant',
    method: 'GET',
    params
  })
}

export function getManageStoresList(params) {
  return request({
    url: 'finance/merchant',
    method: 'GET',
    params
  })
}
export function getManageGroupList(params) {
  return request({
    url: '/finance/group',
    method: 'GET',
    params
  })
}

export function getOperatingGroupList(params) {
  return request({
    url: '/operating/group',
    method: 'GET',
    params
  })
}
/**
 * 获取店员列表
 * getStaffList => finanace
 * getManageStaffList => manane
 * @param {String} type 订单标识
 * @param {Number} id 订单id
 */

export function getStaffList(params) {
  return request({
    url: '/operating/store',
    method: 'GET',
    params
  })
}

export function getManageStaffList(params) {
  return request({
    url: '/finance/store',
    method: 'GET',
    params
  })
}

/**
 * 获取店员列表
 * getOrderList => finanace
 * getManageOrderList => manane
 * @param {String} type 订单标识
 * @param {Number} id 订单id
 */

export function getOrderList(params) {
  return request({
    url: '/operating/staff',
    method: 'GET',
    params
  })
}

export function getManageOrderList(params) {
  return request({
    url: '/finance/staff',
    method: 'GET',
    params
  })
}

/**
 * 获取订单详情
 * @param {String} type 订单标识
 * @param {Number} id 订单id
 */

export function getOrderDetail(num) {
  return request({
    url: 'operating/order-detail',
    method: 'GET',
    params: {
      order_number: num
    }
  })
}

/**
 * 获取退款详情
 * @param {String} type 订单标识
 * @param {Number} id 订单id
 */

export function getRefundDetail(num) {
  return request({
    url: 'operating/refund-detail',
    method: 'GET',
    params: {
      refund_no: num
    }
  })
}

